module.exports = __webpack_public_path__ + "static/media/app_store_badge_en_color_40.ff0d03ec.svg";